<template>
  <div class='modal-pay lh1'>
    <header class="header">
      <p class="fs16 tac title">应版权方要求，该课程需付费播放，购买后可学习完整课程</p>
    </header>
    <div class="course flex aic">
      <img :src="courseInfo.bgimg" alt="" class="course-img">
      <div class="course-info">
        <p class="course-name fs16">{{courseInfo.name | filterTitle}}</p>
        <p class="course-count" :class="{'course-new_count': courseInfo.is_activity}" v-if="courseInfo.resource_list">总课时：{{courseInfo.resource_list.total}}节</p>
        <p class="course-time">{{courseInfo.is_pay === 1 ? '课程续费，有效期将自动叠加至' : '成功购买后观看有效期至'}}：{{Tools.formatDate(courseInfo.end_time, 'Y年MM月DD日')}} </p>
        <p class="course-price fs18" v-if="!courseInfo.is_activity">￥{{userInfo.is_web_vip ? courseInfo.vip_price : courseInfo.price}}</p>
        <div v-else class="course-activity flex aic jcb" :class="courseInfo.discount ? 'zk-bg' : 'yh-bg'">
          <div class="flex">
            <span v-if="courseInfo.discount" class="course-discount tac dib">限时{{courseInfo.discount * 10}}折</span>
            <span v-else class="course-discount tac dib">立减{{userInfo.is_web_vip ? (courseInfo.original_vip_price -
                courseInfo.vip_price).toFixed(2) : (courseInfo.original_price - courseInfo.price).toFixed(2)}}元</span>
            <p class="course-activity-box">
              <span class="fs18 course-activity-price dib">￥{{userInfo.is_web_vip ? courseInfo.vip_price : courseInfo.price}}</span>
              <s>￥{{userInfo.is_web_vip ? courseInfo.original_vip_price : courseInfo.original_price}}</s>
            </p>
          </div>
          <div class="course-end pr10 fs12" v-if="activity_time">
            <p v-html="`距活动结束：${activity_time}`"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="vip csp por flex-col jcb" @click.stop="changeVip()" :class="{'vip-active': isChecked}" v-if="!userInfo.is_web_vip">
      <div class="pay-icon tick_icon poa"></div>
      <p class="vip-text">开通会员，当前课程仅需<span class="vip-price">{{courseInfo.vip_price}}</span>元</p>
      <div class="flex aic jcb" v-if="vipInfo.price">
        <div class="vip-text fs16 flex aic">
          <i class="pay-icon vip_icon"></i><span class="pr5">{{vipInfo.goods_name}}</span>￥{{vipInfo.real_price}}
          <template v-if="(+vipInfo.real_price !== +vipInfo.price)">
            <p><s class="fs14 vip-oldPrice">￥{{vipInfo.price}}</s></p>
            <p v-if="vipInfo.discount" class="fs12 vip-zk"><span class="vip-time">限时</span><span class="vip-discount">{{vipInfo.discount*10}}折</span></p>
            <p v-else class="fs12 vip-yh">立减{{(vipInfo.price - vipInfo.real_price).toFixed(2)}}元</p>
          </template>
        </div>
        <p class="vip-text" @click.stop="OpenRouter('/user/remark')"><span class="vam">查看详情</span><i class="pay-icon right_arrow dib"></i></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ModalPay',
  props: {
    courseInfo: {
      type: Object,
      defalut: {}
    },
    vipInfo: {
      type: Object,
      defalut: {}
    },
    checked: {
      type: Boolean,
      defalut: false
    },
    // 活动倒计时
    activity_time: {
      type: String,
      defalut: ''
    }
  },
  filters: {
    filterTitle (text) {
      text = text ? text.split(/[:：]/) : '';
      return text[1] || text[0];
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'allGrades']),
  },
  watch: {
    courseInfo (item) {
      if (this.checked) {
        this.changeVip(true);
      }
    },
  },
  data () {
    return {
      isChecked: false, // 是否选中会员
    }
  },
  created () {

  },
  methods: {
    changeVip (bool = false) {
      this.isChecked = bool ? bool : !this.isChecked;
      this.$emit('click-checked', this.isChecked);
    }
  }
}
</script>

<style scoped lang='less'>
@import '../../assets/less/function';

.pay-icon {
  .spirit(url(../../assets/images/vip_icon.png));
  &.vip_icon {
    margin-right: 8px;
    &:after {
      width: 16px;
      height: 15px;
      background-position: -164px -26px;
    }
  }
  &.right_arrow {
    margin-left: 8px;
    &:after {
      width: 5px;
      height: 9px;
      background-position: -187px -29px;
    }
  }
  &.tick_icon {
    top: -1px;
    left: -1px;
    &:after {
      width: 32px;
      height: 32px;
      background-position: -131px -48px;
      border-radius: 8px 0 0 0;
    }
  }
  &.tick_icon_active {
    &:after {
      background-position: -168px -48px;
    }
  }
}

.header {
  line-height: 76px;
  background: url(../../assets/images/vip/pay_header.png) no-repeat top left /
    100% 100%;
  .title {
    color: rgba(255, 255, 255, 0.8);
  }
}
.course {
  padding: 30px 0 14px 100px;
  &-img {
    width: 110px;
    height: 126px;
    border-radius: 8px 10px 10px 10px;
  }
  &-info {
    padding-left: 24px;
  }
  &-name {
    color: #333f4e;
  }
  &-count {
    color: #666f7a;
    padding: 16px 0;
  }
  &-new_count {
    padding: 14px 0;
  }
  &-price {
    padding-top: 23px;
    color: #ff2517;
  }
  &-activity {
    width: 579px;
    margin-top: 16px;
    border-radius: 5px;
    color: #ffffff;
    &-box {
      height: 36px;
      line-height: 36px;
    }
    &-price {
      padding: 0 17px 0 16px;
    }
  }
  &-discount {
    padding: 11px 13px 11px 11px;
    height: 36px;
    background: #ffe8c0;
    border-radius: 4px 18px 18px 4px;
    color: #a56f2b;
  }
  .zk-bg {
    background: url(../../assets/images/vip/pay_icon1.png) no-repeat top left /
      100% 100%;
  }
  .yh-bg {
    background: url(../../assets/images/vip/pay_icon2.png) no-repeat top left /
      100% 100%;
  }
}
.vip {
  margin: 16px 64px 30px;
  padding: 21px 30px 21px 50px;
  height: 90px;
  background: #ffffff;
  border: 1px solid #999fa6;
  border-radius: 8px;

  &-price {
    color: #ff2517;
  }
  &-text {
    color: #a56f2b;
  }
  &-active {
    background: #fff8ed;
    border: 1px solid #ce800b;
    .tick_icon {
      .pay-icon .tick_icon_active;
    }
  }
  &-oldPrice {
    padding: 0 20px;
  }
  &-zk {
    height: 22px;
    border: 1px solid #ff5824;
    border-radius: 4px;
    color: #ff5d24;
  }
  &-yh {
    padding: 4px 8px 5px;
    color: #ffffff;
    background: linear-gradient(90deg, #ff3b5f 0%, #ff1f48 100%);
    border-radius: 2px 8px 2px 8px;
  }
  &-time {
    padding: 3px 5px 3px 3px;
    line-height: 21px;
    background: linear-gradient(90deg, #ff8726 0%, #ff5724 100%);
    border-radius: 4px 0px 10px 4px;
    color: #ffffff;
  }
  &-discount {
    padding: 0 9px 0 7px;
  }
}
</style>
